import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import SettingsCentralMappingTablesCellsEditableTextCell from 'lumen/components/settings/central-mapping/tables/cells/editable-text-cell';
import type { CentralMappingMappingEntry } from 'lumen/models';

interface MarketSettingsCentralMappingTablesCellsTdDescriptionSignature {
  Args: {
    cellData: string;
    column: {
      isReadOnly?: boolean;
    };
    row: {
      isParent?: boolean;
      mappingEntry: CentralMappingMappingEntry;
    };
    rowMeta: {
      isSelected: boolean;
    };
  };
}

export default class MarketSettingsCentralMappingTablesCellsTdDescription extends Component<MarketSettingsCentralMappingTablesCellsTdDescriptionSignature> {
  @service declare centralMapping: Services['central-mapping'];

  get isReadOnly(): boolean {
    return (
      this.args.column.isReadOnly === true ||
      Boolean(this.args.rowMeta.isSelected) ||
      Boolean(this.args.row.isParent)
    );
  }

  @action setDescription(value: string): void {
    this.args.row.mappingEntry.description = value;

    const isParentRow = Boolean(this.args.row.isParent);
    this.centralMapping.trackMappingEntryChanged({
      mappingChange: 'description',
      rowType: isParentRow ? 'parent' : 'child',
    });
  }

  <template>
    <SettingsCentralMappingTablesCellsEditableTextCell
      @cellDataTestId="central-mapping-td-description"
      @isReadOnly={{this.isReadOnly}}
      @setValue={{this.setDescription}}
      @showTooltip={{true}}
      @value={{@cellData}}
    />
  </template>
}
